import BaseLayout from '@/layouts/BaseLayout';
import '../styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { ContactUS } from '@/app/pages/Contactus';
import { useScrollToTopOnRouteChange } from '@/hooks/scrolltotop';
import { Services } from '@/app/pages/Services';
import { AboutUS } from '@/app/pages/About Us';
import { PrivacyPolicy } from '@/app/pages/PrivacyPolicy';
import { TermsCondition } from '@/app/pages/TermsCondition';
import FaqPage from './pages/Faqs';
import Testimonals from './pages/Testimonals';
import SingleNews from './pages/NewsDetail';
import { ServicesAll } from '@/constants/ServicesAll';
import { CommonServicePage } from '@/components/services/CommonServicePage';
import { News } from '@/components/home/News';
function App() {
  console.log('test test');
  return (
    <Router>
      <ScrollHandler />
      <Routes>
        <Route element={<BaseLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUS />} />
          <Route path="/news/:id" element={<SingleNews />} />
          <Route path="/faqs" element={<FaqPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<AboutUS />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route path="/testimonals" element={<Testimonals />} />
          <Route path="/news" element={<News />} />
          {ServicesAll.map((service, index) => (
            <Route
              key={index}
              path={service.link}
              element={<CommonServicePage currentService={service} />}
            />
          ))}
        </Route>
      </Routes>
    </Router>
  );
}
const ScrollHandler = () => {
  useScrollToTopOnRouteChange();
  return null;
};

export default App;
